import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import * as modalsActions from '../actions/actionsModals';

import { Row, Col, Modal } from "react-bootstrap";
import Project from '../components/resume/Project'

class ProjectsContainer extends Component {
  constructor (props) {
    super(props);

    this.handleMouseClick = this.handleMouseClick.bind(this);
    this.slickSettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    };
  }

  handleMouseClick (project) {
    this.props.actions.openModal(project);
  }

  render() {
    const { openModals } = this.props.modals;
    const { actions, items, onMouseOver, onMouseOut } = this.props;

    return (
      <div>
        {items.map((row, i) => (
          <div key={i} className="sub-block">
            <Row>
              <Col xs={12} sm={6}>
                <strong className="work-name"><em>{row.title}</em></strong>
              </Col>
            </Row>
            {row.subtitle && <span className="work-position">{row.subtitle}</span>}
            <div className="projects-row">
              {row.projects.map((project, i) => 
                <Project
                  key={i}
                  data={project}
                  onMouseOver={onMouseOver}
                  onMouseOut={onMouseOut}
                  onMouseClick={this.handleMouseClick}
                />)}
            </div>
          </div>
        ))}

        {openModals.map((modalObject, i) => (
        <Modal key={i} show={true} onHide={() => actions.closeModal(modalObject.uuid)} className="project-modal">
          <Modal.Body>
            <Slider {...this.slickSettings}>
              {modalObject.projects.map((project, i) => 
                <div key={i}>
                  <img src={`./images/resume/${project.image}`} alt={project.caption} />
                </div>
              )}
            </Slider>
          </Modal.Body>
        </Modal>
        ))}
      </div>
    );
  }
}

ProjectsContainer.propTypes = {
  items: PropTypes.array.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired
};

function mapStateToProps(state, props) {
  return {
    modals: state.modals
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(modalsActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsContainer);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer.js